import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-card-skelton',
  templateUrl: './card-skelton.component.html',
  styleUrls: ['./card-skelton.component.css']
})
export class CardSkeltonComponent implements OnInit {
  @Input() title: any;

  constructor() { }

  ngOnInit(): void {
  }

}
